import { jsx as _jsx } from "preact/jsx-runtime";
import { useMemo, useContext } from 'preact/compat';
import { ThemeContext } from 'styled-components';
import StyledElements from './styles';
const months = [
    { label: 'January', month: 0 },
    { label: 'February', month: 1 },
    { label: 'March', month: 2 },
    { label: 'April', month: 3 },
    { label: 'May', month: 4 },
    { label: 'June', month: 5 },
    { label: 'July', month: 6 },
    { label: 'August', month: 7 },
    { label: 'September', month: 8 },
    { label: 'October', month: 9 },
    { label: 'November', month: 10 },
    { label: 'December & January', month: 11 },
];
function WinterWonderlandHeader(props) {
    const { monthDate, changeYear, changeMonth, prefix, isAfterNov, usedYear, monthsShown, } = props;
    const themeContext = useContext(ThemeContext);
    const changeDate = (month, year) => {
        changeMonth(month);
        changeYear(year);
    };
    const currYear = useMemo(() => usedYear ?? new Date().getFullYear(), [usedYear]);
    const filteredMonths = months.filter((date) => {
        if (isAfterNov) {
            return date.month === 11;
        }
        return true;
    });
    if (monthsShown !== 1) {
        return (_jsx(StyledElements.Wrapper, { ...themeContext, children: _jsx(StyledElements.Heading, { children: months.find((monthObj) => monthObj.month === monthDate.getUTCMonth())?.label ?? 'December & January' }) }));
    }
    return (_jsx(StyledElements.Wrapper, { ...themeContext, children: filteredMonths.filter((month) => [10, 11].includes(month.month)).map((option) => {
            const isActive = monthDate.getUTCMonth() === option.month;
            return (_jsx(StyledElements.Button, { type: "button", onClick: () => changeDate(option.month, currYear), isActive: isActive, children: option.label }, `${prefix}-${option.label}`));
        }) }));
}
WinterWonderlandHeader.defaultProps = {
    monthsShown: 2,
};
export default WinterWonderlandHeader;
